import { Button, Flex } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { ArrowLeftOutlined } from "@ant-design/icons";
import { HrmStationeryTable } from "../../components/hrm/HrmStationeryTable";
import { ModalAddStationery } from "../../components/modal/hrm/ModalAddStationery";
import { IQueryStationeryPeriod } from "../../models/Hrm";
import { useGetAllStationeryPeriods } from "../../query/HrmQuery";

const PersonalStationery = () => {
  const navigate = useNavigate();

  const [filter, setFilter] = useState<IQueryStationeryPeriod>({
    page: 1,
    limit: 10,
  });
  const [isOpen, setIsOpen] = useState(false);
  const { data, isLoading } = useGetAllStationeryPeriods(filter);

  return (
    <Flex vertical gap={3} className="px-3 mt-3">
      <Flex align="center" justify="space-between" wrap="wrap" gap="small">
        <Button
          type="default"
          size="large"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate(-1)}
          className=""
        >
          Quay lại
        </Button>
      </Flex>
      <Flex vertical gap="large" className="w-full">
        <HrmStationeryTable
          data={data?.data || []}
          isLoading={isLoading}
          filter={filter}
          setFilter={setFilter}
        />
      </Flex>
      <ModalAddStationery isOpen={isOpen} setIsOpen={setIsOpen} />
    </Flex>
  );
};

export default PersonalStationery;
